import React from "react";
import AddUser from "./AddUser";

function Crud() {
  return (
    <div className="p-5 text-center bg-light">
      <h1 className="mb-5">REACT CRUD APP</h1>
      <AddUser />
    </div>
  );
}

export default Crud;
